// Initialize tracking when module loads
console.log("otto-custom.js module initializing 2");
// Flag to prevent attaching the listener multiple times
let trackingInitialized = false;
function initializeTracking() {
  if (trackingInitialized) return;
  console.log(
    "Initializing tracking listener: Attaching directly to elements.",
  );
  const trackedLinks = document.querySelectorAll(".ui-tracked-link");
  trackedLinks.forEach((link) => {
    link.removeEventListener("click", handleTrackedClick);
    link.addEventListener("click", handleTrackedClick);
  });
  trackingInitialized = true;
}
function handleTrackedClick(e) {
  const action_item = this.dataset.actionItem;
  const tn_id = this.dataset.tnId;
  const button_text = this.dataset.buttonText;
  const lender_client_id = document.body.dataset.lenderClientId;
  let destination_url = this.dataset.destinationUrl;
  let original_method = this.dataset.originalMethod || "GET";
  let isFormButton = false;
  let formHandledByJS = false;
  let formElement = null;
  if (this.tagName === "BUTTON" && (formElement = this.closest("form"))) {
    isFormButton = true;
    formHandledByJS = formElement.getAttribute("data-action")?.includes("#");
    const form_action = formElement.getAttribute("action");
    const form_data_url = formElement.dataset.url;
    const hiddenMethod = formElement.querySelector('input[name="_method"]');
    let form_method = hiddenMethod
      ? hiddenMethod.value.toUpperCase()
      : (formElement.getAttribute("method") || "POST").toUpperCase();
    if (!formHandledByJS) {
      console.log("[handleTrackedClick] Button in standard form detected:", {
        destination_url_from_button: destination_url,
        form_action,
        original_method: form_method,
      });
      destination_url = destination_url || form_action;
      original_method = form_method;
    } else {
      console.log("[handleTrackedClick] Button in JS-handled form detected:", {
        destination_url_from_button: destination_url,
        form_data_url,
        form_action,
        original_method: form_method,
      });
      destination_url = destination_url || form_data_url || form_action;
      original_method = form_method;
    }
  } else if (this.tagName === "A") {
    destination_url = destination_url || this.getAttribute("href");
    original_method = (this.dataset.turboMethod || "GET").toUpperCase();
    console.log("[handleTrackedClick] Anchor tag detected:", {
      destination_url,
      original_method,
    });
  } else {
    console.warn(
      "[handleTrackedClick] Unhandled tracked element type:",
      this.tagName,
    );
    destination_url = destination_url || this.getAttribute("href");
    original_method = "GET";
  }
  const defaultPrevented = !(isFormButton && formHandledByJS);
  if (defaultPrevented) {
    if (e.cancelable) {
      e.preventDefault();
      console.log("[handleTrackedClick] Default behavior PREVENTED.");
    } else {
      console.log("[handleTrackedClick] Default behavior NOT preventable.");
    }
  } else {
    console.log(
      "[handleTrackedClick] Allowing default behavior for Stimulus form.",
    );
  }
  console.log("Click data (Final):", {
    action_item,
    destination_url,
    tn_id,
    button_text,
    lender_client_id,
    original_method,
  });
  const logInteractionPromise = fetch("/user_interactions/log_action", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
        ?.content,
    },
    body: JSON.stringify({
      destination_url:
        destination_url || formElement?.dataset.url || window.location.href,
      action_item,
      tn_id,
      button_text,
      lender_client_id,
    }),
  }).catch((error) => {
    console.error("Error logging interaction:", error);
  });
  if (defaultPrevented) {
    logInteractionPromise.then(() => {
      const isTrackerOpen =
        document.body.dataset.notificationTrackerOpen === "true";
      console.log(
        `[handleTrackedClick] isTrackerOpen: ${isTrackerOpen}, destination_url: ${destination_url}`,
      );
      if (isTrackerOpen && destination_url) {
        fetch(destination_url, {
          method: original_method,
          headers: {
            Accept:
              "text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.7",
            "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
              ?.content,
          },
        })
          .then((response) => {
            if (!response.ok) {
              console.error(
                `Async action fetch error! Status: ${response.status}`,
              );
            }
          })
          .catch((error) => {
            console.error(
              `Error triggering async action ${original_method} ${destination_url}:`,
              error,
            );
          });
      } else if (destination_url) {
        if (isFormButton && formElement && !formHandledByJS) {
          formElement.submit();
        } else if (!isFormButton) {
          window.location.href = destination_url;
        } else {
          console.warn("Unexpected state for navigation/submission.");
        }
      } else {
        console.log("Click logged, no navigation.");
      }
    });
  }
}
document.addEventListener("turbo:load", initializeTracking);
window.Previous = function () {
  window.history.back();
};
console.log("otto-custom.js loaded");
